import { Icon } from '@iconify/react';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';
import watermarkImage from '../assets/common/logo-watermark.png';
import { AppLogo } from '../modules/shared/components';

export default function PublicLayout() {
  return (
    <Stack direction='column' gap={3} sx={{ minHeight: '100vh' }}>
      <Stack
        direction='row'
        component='header'
        sx={{
          padding: '28px 160px',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '8px solid',
          borderColor: 'primary.light',
          maxWidth: 'calc(96rem + 320px)', // 96rem + 2 * 160px
        }}
      >
        <AppLogo showTagline orientation='horizontal' size='md' />
        <div className='column gap-1'>
          <div className='row'>
            <Icon icon='ic:baseline-email' />
            <MuiLink href='mailto:admin@scpl.net.in' sx={{ textDecoration: 'none' }}>
              Email ID - admin@scpl.net.in
            </MuiLink>
          </div>
          <div className='row'>
            <Icon icon='ri:whatsapp-fill' />
            <MuiLink href='https://wa.me/7798044910' sx={{ textDecoration: 'none' }}>
              Whatsapp no. - 7798044910
            </MuiLink>
          </div>
        </div>
      </Stack>
      <Stack
        direction='column'
        flex={1}
        sx={{ padding: '24px 100px 64px', maxWidth: 'calc(96rem + 200px)', position: 'relative' }}
      >
        <Outlet />
        <Stack
          aria-hidden
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: -1,
            '& img': {
              width: '100%',
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              userSelect: 'none',
              opacity: 0.03,
            },
          }}
        >
          <img src={watermarkImage} alt='' />
        </Stack>
      </Stack>
    </Stack>
  );
}
